var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMainWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 717",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.339057 717C3.09424 697.945 -26.8915 617.548 96.3834 618.894C250.477 620.575 210.379 576.16 326.489 564.595C422.033 555.079 531.583 505.259 561.097 482.868C622.874 436 667.646 338.277 740.679 355.24C813.713 372.203 877.742 266.686 938.27 266.686C1072.83 266.686 1127.3 155.536 1160.87 135.809C1191.89 117.582 1404.98 0 1440 0V717H0.339057Z",
    fill: "#8FDFE5",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M414 652.616C415.608 635.87 529.758 556.81 599.623 572.938C636.189 581.379 706.449 551.712 766.416 497.532C826.382 443.351 858.24 396.791 900.975 382.507C943.709 368.223 985.686 294.26 1026.6 308.566C1091.39 331.224 1115.92 350.316 1181.75 316.33C1247.57 282.345 1258.1 227.238 1299.11 227.238C1331.92 227.238 1409.44 153.568 1440 125V717H414V652.616Z",
    fill: "#A7BDFF",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M668 717C669.389 697.843 703.835 573.796 766 575.148C843.706 576.839 817.619 584.358 878.5 531.386C913.5 500.933 941 464.484 964.534 460.703C1004.36 454.303 1043.73 336.747 1099.7 362.665C1155.67 388.583 1134.24 463.519 1191.1 424.642C1247.97 385.765 1307.07 278.87 1342.5 278.87C1370.84 278.87 1418 188 1440 188V717H668Z",
    fill: "#8FDFE5",
    fillOpacity: 0.25
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainWhite);
export default __webpack_public_path__ + "static/media/main_white.7bee72cac183ce66589def638a1e05e4.svg";
export { ForwardRef as ReactComponent };